import React from "react";
import redCross from "../../../images/red-cross.png";
import TextBlock from "./TextBlock/TextBlock";

const NotFoundBlock = (props) => {
  return (
    <div className="notFoundBlock rounded-lg p-5 ml-auto mr-auto mt-16 relative">
      <div className="redCross">
        <img src={redCross} alt="" />
      </div>
      <div className="flex flex-col">
        <div>
          <TextBlock
            big
            content="Cannot find Narrative blog post"
            customStyle={{ color: "rgb(246,61,74)" }}
          />
        </div>
        <div className="mt-8">
          <TextBlock
            content="It appears that the URL you have given us is"
            customStyle={{ color: "rgb(246,61,74)" }}
          />
          <TextBlock
            content="not a live post. Please return to your"
            customStyle={{ color: "rgb(246,61,74)" }}
          />
          <TextBlock
            content="website and publish the post"
            customStyle={{ color: "rgb(246,61,74)" }}
          />
        </div>

        <div className="mt-10">
          <TextBlock
            content="How to fix this"
            customStyle={{ color: "rgb(0, 122, 255)" }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundBlock;
